import { ApolloError, useQuery } from '@apollo/client'

import { GetSelectableNationalContractReferencesQuery } from '../../../types'
import { GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES } from '../Queries'

export const useSelectableNationalContractReferences = (): {
  data: GetSelectableNationalContractReferencesQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<GetSelectableNationalContractReferencesQuery>(GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES, {
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
